import { styled, Card } from '@mui/material';

export const CardType = styled(Card)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'initial',
  alignItems: 'center',
  position: 'fixed',
  padding: '2em',
  paddingTop: '0px',
  borderRadius: '13px',
  boxShadow: '2px 1px 2px 1px rgba(0,0,0,0.33)',
  color: '#000000',
  background: 'linear-gradient(195deg, rgba(227, 230, 232, 0.71) 0%, rgba(131, 140, 149, 0.7) 100%)',
  right: '3%',
  bottom: '14%',
  maxHeight: '80%',
  minWidth: '20%',
  maxWidth: '25%',
  height: 'auto',
  zIndex: '10000',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '0.5em',
    background: 'rgb(80, 80, 80, 0)',
  },
  '&::-webkit-scrollbar-track': {
    boxshadow: 'inset 0 0 6px rgba(0, 0, 0, 0.2)',
    webkitboxshadow: 'inset 0 0 6px rgba(0, 0, 0, 0.2)',
    scrollbarColor: 'white',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundcolor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    scrollbarColor: 'white',
    background: 'rgb(50, 50, 50, 0.3)',
  },
});
